'use strict';

export const UPDATE_FILTER = 'contact/UPDATE_FILTER';
export const DATA_LOADED = 'contact/DATA_LOADED';
export const MORE_LOADING = 'contact/MORE_LOADING';
export const MORE_LOADED = 'contact/MORE_LOADED';
export const IDS_LOADED = 'contact/IDS_LOADED';
export const LOADING_CANCELLED = 'contact/LOADING_CANCELLED';
export const LOADING_FAILED = 'contact/LOADING_FAILED';